import React from 'react';
import { CheckCircleIcon, FileTextIcon, DollarSignIcon, ClipboardIcon } from 'lucide-react';
export function App() {
  return <div className="w-full min-h-screen bg-black text-white dot-grid-background" data-id="element-0">
      {/* Header */}
      <header className="w-full border-b border-gray-800 fixed top-0 z-50 bg-black" data-id="element-1">
        <div className="max-w-7xl mx-auto px-6 py-6" data-id="element-2">
          <h1 className="text-xl font-light tracking-[0.3em] flex items-center gap-3" data-id="element-3">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oWTg2yEhHKrcK3S6tRhxVa/ArdenCare_Arrow_Favicon.png" alt="Arden Care Logo" className="w-6 h-6" data-id="element-4" />
            ARDEN CARE
          </h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="w-full px-6 py-24 md:py-32 pt-32 md:pt-40 border-b border-gray-800" data-id="element-5">
        <div className="max-w-4xl mx-auto text-center" data-id="element-6">
          <h2 className="text-5xl md:text-6xl font-bold tracking-tight mb-6" data-id="element-7">
            Grow your home health agency profitably
          </h2>
          <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto" data-id="element-8">
            Spend less time clicking and more time caring with Arden's AI
            powered workflows
          </p>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="w-full px-6 py-20 bg-zinc-950 border-b border-gray-800" data-id="element-9">
        <div className="max-w-4xl mx-auto" data-id="element-10">
          <h3 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-11">
            Work with Arden Care to:
          </h3>
          <ul className="space-y-4 text-lg md:text-xl" data-id="element-12">
            <li className="flex items-start" data-id="element-13">
              <CheckCircleIcon className="w-6 h-6 mr-3 mt-1 flex-shrink-0 text-blue-400" data-id="element-14" />
              <span className="text-gray-300" data-id="element-15">Convert referrals faster</span>
            </li>
            <li className="flex items-start" data-id="element-16">
              <CheckCircleIcon className="w-6 h-6 mr-3 mt-1 flex-shrink-0 text-blue-400" data-id="element-17" />
              <span className="text-gray-300" data-id="element-18">
                Accelerate start of care scheduling
              </span>
            </li>
            <li className="flex items-start" data-id="element-19">
              <CheckCircleIcon className="w-6 h-6 mr-3 mt-1 flex-shrink-0 text-blue-400" data-id="element-20" />
              <span className="text-gray-300" data-id="element-21">
                Optimize reimbursement with accurate OASIS assessments
              </span>
            </li>
            <li className="flex items-start" data-id="element-22">
              <CheckCircleIcon className="w-6 h-6 mr-3 mt-1 flex-shrink-0 text-blue-400" data-id="element-23" />
              <span className="text-gray-300" data-id="element-24">Elevate your star ratings</span>
            </li>
            <li className="flex items-start" data-id="element-25">
              <CheckCircleIcon className="w-6 h-6 mr-3 mt-1 flex-shrink-0 text-blue-400" data-id="element-26" />
              <span className="text-gray-300" data-id="element-27">Drive referral growth</span>
            </li>
            <li className="flex items-start" data-id="element-28">
              <CheckCircleIcon className="w-6 h-6 mr-3 mt-1 flex-shrink-0 text-blue-400" data-id="element-29" />
              <span className="text-gray-300" data-id="element-30">
                Keep your best caregivers and staff members
              </span>
            </li>
          </ul>
        </div>
      </section>
      {/* Features Section */}
      <section className="w-full px-6 py-20 border-b border-gray-800" data-id="element-31">
        <div className="max-w-7xl mx-auto" data-id="element-32">
          <h3 className="text-3xl md:text-4xl font-bold mb-16 text-center" data-id="element-33">
            The features we're developing include:
          </h3>
          <div className="grid md:grid-cols-3 gap-8 md:gap-12" data-id="element-34">
            {/* Feature 1 */}
            <div className="border border-gray-800 rounded-lg p-8 space-y-4" data-id="element-35">
              <div className="w-12 h-12 bg-zinc-900 rounded-lg flex items-center justify-center mb-4" data-id="element-36">
                <FileTextIcon className="w-6 h-6 text-blue-400" data-id="element-37" />
              </div>
              <h4 className="text-xl font-semibold" data-id="element-38">Automated Intake</h4>
              <p className="text-gray-400 leading-relaxed" data-id="element-39">
                Our AI parses your faxes, automatically adds referrals to your
                EMR, checks benefits, and completes pre-authorizations.
              </p>
            </div>
            {/* Feature 2 */}
            <div className="border border-gray-800 rounded-lg p-8 space-y-4" data-id="element-40">
              <div className="w-12 h-12 bg-zinc-900 rounded-lg flex items-center justify-center mb-4" data-id="element-41">
                <DollarSignIcon className="w-6 h-6 text-blue-400" data-id="element-42" />
              </div>
              <h4 className="text-xl font-semibold" data-id="element-43">AI Assisted Billing</h4>
              <p className="text-gray-400 leading-relaxed" data-id="element-44">
                We automate billing, collections, and claims appeals leading to
                fewer denied claims and faster collections.
              </p>
            </div>
            {/* Feature 3 */}
            <div className="border border-gray-800 rounded-lg p-8 space-y-4" data-id="element-45">
              <div className="w-12 h-12 bg-zinc-900 rounded-lg flex items-center justify-center mb-4" data-id="element-46">
                <ClipboardIcon className="w-6 h-6 text-blue-400" data-id="element-47" />
              </div>
              <h4 className="text-xl font-semibold" data-id="element-48">
                AI Scribe & Clinical Documentation
              </h4>
              <p className="text-gray-400 leading-relaxed" data-id="element-49">
                Our AI captures notes during all visits, automates OASIS
                Assessment forms, develops Care Plans and improves coding.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="w-full px-6 py-20 bg-zinc-950 border-b border-gray-800" data-id="element-50">
        <div className="max-w-4xl mx-auto text-center" data-id="element-51">
          <p className="text-2xl md:text-3xl mb-8" data-id="element-52">
            Interested in learning more?
          </p>
          <a href="mailto:jonathan@ardencare.cc" className="inline-block bg-white text-black px-8 py-4 rounded-lg text-lg font-medium hover:bg-gray-200 transition-colors" data-id="element-53">
            Contact Us
          </a>
        </div>
      </section>
      {/* Footer */}
      <footer className="w-full border-t border-gray-800" data-id="element-54">
        <div className="max-w-7xl mx-auto px-6 py-6" data-id="element-55">
          <p className="text-sm text-gray-500" data-id="element-56">© 2025 Arden Care</p>
        </div>
      </footer>
    </div>;
}